import { useEffect, useState } from "react";
import Header from "../../Components/Header";
import SidePanel from "../../Components/SidePanel";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Components/Loader";
import Search from "../../Components/Search";
import CreateUniversity from "./CreateUniversity";
import UniversityTable from "./UniversityTable";
import UniversityFilter from "./UniversityFilter";
import {
  LIST_UNIVERSITIES,
  UNIVERSITY_LIST_DELETE,
  UNIVERSITY_LIST_DELETE_RESET,
} from "../../Actions/universityAction";
import { University_form } from "../../Models/universityModel";

export default function University() {
  const [hideSidepanel, setHideSidePanel] = useState(true);
  const [FormOpener, setFormOpener] = useState(false);
  const [EditFormOpener, setEditFormOpener] = useState(false);
  const [University_Lists, setUniversity_Lists] = useState([]);
  const [Alert, setAlert] = useState(false);
  const [UniversityID, setUniversityID] = useState("");
  const [University_Search_Name, setUniversity_Search_Name] = useState("");

  const { university_list_Loading, UniversityList, university_list_Error } =
    useSelector((state) => state.UNIVERSITY_LIST_REDUCER);

  const { Delete_University_Success, Delete_University_Error } = useSelector(
    (state) => state.UNIVERSITY_DELETE_REDUCER
  );

  const dispatch = useDispatch();

  const handleHide = (e) => {
    e.preventDefault();
    setHideSidePanel(!hideSidepanel);
  };

  /* handle Searching according to University name start  */
  const handleSearch_data = (e) => {
    if (e.target.value === "" || e.target.value === null) {
      setUniversity_Lists(UniversityList);
    } else {
      setUniversity_Search_Name(e.target.value);
    }
  };

  const handle_University_Search_data = async () => {
    const new_University_Data = University_Lists?.filter((el) =>
      el.University_Name.toLowerCase().includes(
        University_Search_Name.toLowerCase()
      )
    );
    setUniversity_Lists(new_University_Data);
  };

  const handleUniversityData_Searching = (e) => {
    e.preventDefault();
    handle_University_Search_data();
  };
  const handleKey = (e) => {
    if (e.key === "Enter") {
      handle_University_Search_data();
    }
  };
  /* handle Searching according to University name End  */
  const handleFormClose = () => {
    setFormOpener(!FormOpener);
  };

  const handleEditorForm = () => {
    setEditFormOpener(!EditFormOpener);
  };

  const handleEditUniversityData = (Id) => {
    setUniversityID(Id);
    handleEditorForm();
  };

  const University_Lists_Get_Req = () => {
    dispatch(LIST_UNIVERSITIES());
  };

  const handleDeleteUniversity = (ID) => {
    dispatch(UNIVERSITY_LIST_DELETE(ID));
  };

  useEffect(() => {
    University_Lists_Get_Req();
  }, [Delete_University_Success]);

  useEffect(() => {
    setUniversity_Lists(UniversityList);
  }, [UniversityList]);

  useEffect(() => {
    if (Delete_University_Success) {
      setAlert(Delete_University_Success);
    }
    if (Delete_University_Error) {
      setAlert(Delete_University_Error);
    }

    if (Delete_University_Error || Delete_University_Success) {
      setTimeout(() => {
        setAlert(false);
        dispatch(UNIVERSITY_LIST_DELETE_RESET());
      }, 2000);
    }
  }, [Delete_University_Success, Delete_University_Error]);

  return (
    <>
      <Header Page={"University"} handleHide={handleHide} />
      {/*<!-- top-right search bar -->*/}
      <SidePanel handleHide={handleHide} hide={hideSidepanel} />
      {/*<!-- Pushable content along with off-canvas opener. -->*/}
      <div className="bs-offset-main bs-canvas-anim">
        <div className="content-body">
          {/*<!--Body-content-->*/}
          <div className="container-fluid">
            <div className="heading-title">
              <div className="row">
                <div className="col-md-12">
                  <div className="home-table-search">
                    {/* University Web Details Search  */}
                    <Search
                      handleSearch={handleSearch_data}
                      handleSearching={handleUniversityData_Searching}
                      handleKey={handleKey}
                      SearchData={University_Search_Name}
                      placeholder={"Search University"}
                    />

                    <div className="right-click Create-btn">
                      <a
                        href="#"
                        className="btn create-contact"
                        onClick={() => handleFormClose()}>
                        Create University
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {Alert && (
              <div className="side_drawer">
                <div
                  className={Delete_University_Success ? "Alert2" : "Alert3"}>
                  <span onClick={() => setAlert(false)} className="close">
                    &times;
                  </span>
                  <p>{Alert}</p>
                </div>
              </div>
            )}

            <div className="inner-body">
              <div className="row">
                <div className="col-md-3 col-lg-2">
                  <div className="filter-in-mob-view text-right">
                    <input
                      type="text"
                      name="search"
                      placeholder="Search Contacts..."
                    />
                    <i className="fas fa-filter mob-nav-open"></i>
                  </div>
                  {/*<!-- /filter-in-mob-view -->*/}
                  <UniversityFilter />
                </div>
                {/*<!-- University web Details Table -->*/}

                {university_list_Loading ? (
                  <div>
                    <Loader />
                  </div>
                ) : university_list_Error ? (
                  <div>
                    <img
                      className="No_data"
                      src="./assets/img/NoRecord.png"
                      alt="data_notfound"
                    />
                  </div>
                ) : (
                  <UniversityTable
                    setUniversity_Lists={setUniversity_Lists}
                    handleEditUniversityData={handleEditUniversityData}
                    handleDeleteUniversity={handleDeleteUniversity}
                    University_Lists_Get_Req={University_Lists_Get_Req}
                    University_Lists={University_Lists}
                    LOADING={university_list_Loading}
                  />
                )}
              </div>
            </div>
            <CreateUniversity
              UniversityID={UniversityID}
              University_Lists_Get_Req={University_Lists_Get_Req}
              handleEditorForm={handleEditorForm}
              EditFormOpener={EditFormOpener}
              FormOpener={FormOpener}
              handleFormClose={handleFormClose}
            />
            {/*<!--/overlay-Create-contact-->*/}
          </div>
        </div>
      </div>
    </>
  );
}
